<template>
  <div class="back-btn" @click="handleBack">
    <svg class="back-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M15 18l-6-6 6-6"/>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'CommonHeader',
  methods: {
    handleBack() {
      // 当连接参数 form=1 时，直接关闭页面（webview）
      if (this.$route && this.$route.query && this.$route.query.form === '1') {
        window.location.href = 'mdb://closeWebPage';
        return;
      }
      if (this.$router && typeof this.$router.back === 'function') {
        this.$router.back();
      } else if (window.history && typeof window.history.back === 'function') {
        window.history.back();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.back-btn {
  position: fixed;
  top: 10px;
  left: 10px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 9999;
  padding: 0;
  margin: 0;
  
  &:active {
    opacity: 0.7;
  }
  
  .back-icon {
    width: 24px;
    height: 24px;
    color: #fff;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  }
}
</style>